module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "coloredFibaBanka.7fb2db4a.png";